/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../../components/UI'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {BathRoomModel} from '../../../bathrooms/models'
import Swal from 'sweetalert2'
import {deleteBathRoomService} from '../../../bathrooms/services/deleteBathRoom.service'
import {enqueueSnackbar} from 'notistack'
import {getBathRoomsService} from '../../../bathrooms/services/getBathRooms.service'
import {Column} from 'react-table'
import {ModalUpdateBathRoom} from '../Modal/ModalUpdateBathRoom'
import {ModalNewBathRoom} from '../Modal/ModalNewBathRoom'
import {getSnackBarToast} from '../../../../../../util/snackBar'

const TableBathRooms: FC = () => {
  const {data, setData, setPagination, loading, setLoading, selected, pagination} = useKTable()
  const {currentTabItem, isAllowed} = useHoteleria()
  const [showModalUpdate, setShowModalUpdate] = useState(false)
  const [showModalNew, setShowModalNew] = useState(false)
  const [bathroomToEdit, setBathroomToEdit] = useState<BathRoomModel | any>(null)

  const handleNew = () => {
    setShowModalNew(true)
  }

  const getSnackBar = (message: string, variant: boolean) => {
    enqueueSnackbar(message, {
      variant: variant ? 'success' : 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    })
  }

  const getBathRooms = async () => {
    setLoading(true)
    const {data: response} = await getBathRoomsService({
      ModuloId: currentTabItem.idToEdit,
      pageNumber: pagination.currentPage,
      size: pagination.perPage,
    })
    if (!response.error) {
      setData(response.data)
      setPagination({
        ...pagination,
        totalResults: response.total,
      })
    }
    setLoading(false)
  }

  useEffect(() => {
    getBathRooms()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    getBathRooms()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const columns: Column<BathRoomModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCell id={props.data[props.row.index].Id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Módulo' />,
      accessor: 'Modulo_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Baño' />,
      accessor: 'TipoBanio_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Código de Baño' />,
      accessor: 'Codigo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Observaciones' />,
      accessor: 'Observaciones',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('BANOS/EDITAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEdit(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
        </>
      ),
    },
  ]

  const handleEdit = (item: BathRoomModel) => {
    setBathroomToEdit(item)
    setShowModalUpdate(true)
  }

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        const mappedSelected = selected.map((item) => ({Id: item}))
        const {data: response} = await deleteBathRoomService(mappedSelected)
        if (!response.error) {
          getSnackBarToast('Se eliminó satisfactoriamente', 'success')
          //   getBathRooms()
        } else {
          getSnackBarToast(response.message, 'error')
        }
        getBathRooms()
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <>
      {isAllowed('BANOS/LISTAR') && (
        <KTCard shadow className='m-5'>
          <div className='d-flex justify-content-end p-2 me-5'>
            {isAllowed('BANOS/AGREGAR') && (
              <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                Agregar
              </button>
            )}
            {isAllowed('BANOS/ELIMINAR') && (
              <button
                className='btn btn-primary me-3'
                disabled={selected.length < 1}
                onClick={handleDelete}
                type='button'
              >
                Eliminar
              </button>
            )}
          </div>
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}

          {showModalUpdate ? (
            <ModalUpdateBathRoom
              show={showModalUpdate}
              setShow={setShowModalUpdate}
              bathRoomToEdit={bathroomToEdit}
              getBathRooms={getBathRooms}
            />
          ) : (
            <></>
          )}
          {showModalNew ? (
            <ModalNewBathRoom
              show={showModalNew}
              setShow={setShowModalNew}
              getBathrooms={getBathRooms}
            />
          ) : (
            <></>
          )}
        </KTCard>
      )}
    </>
  )
}

const TableBathRoomsFromRoomWrapper = () => {
  return (
    <KTableProvider>
      <TableBathRooms />
    </KTableProvider>
  )
}
export {TableBathRoomsFromRoomWrapper}
